import { MoneyAmount } from '../../utils/money';
import { ApplicationUserDto, ApplicationUserModel } from '../types';

export const dtoToApplicationUserModel = (dto: ApplicationUserDto): ApplicationUserModel => {
  return {
    ...dto,
    debts: dto.debts
      ? [...(dto.debts.map((item) => ({ ...item, amount: MoneyAmount.fromMinUnits(item.amount) })) || [])]
      : [],
    accountInfo: dto.accountInfo
      ? {
          ...dto.accountInfo,
          accountBalance: {
            ...dto.accountInfo.accountBalance,
            amount: MoneyAmount.fromMinUnits(dto.accountInfo.accountBalance.amount),
          },
          notReturnFeeSum: MoneyAmount.fromMinUnits(dto.accountInfo.notReturnFeeSum),
        }
      : undefined,
  };
};
